"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19.5 8.48c-.088.054-2.166 1.17-2.166 3.647.098 2.824 2.623 3.814 2.666 3.814-.043.053-.381 1.35-1.382 2.708C17.824 19.82 16.942 21 15.603 21c-1.273 0-1.73-.78-3.2-.78-1.578 0-2.024.78-3.232.78-1.34 0-2.286-1.243-3.124-2.403-1.088-1.517-2.013-3.899-2.046-6.186-.022-1.211.218-2.402.827-3.414.86-1.413 2.395-2.371 4.07-2.403 1.285-.042 2.428.854 3.211.854.751 0 2.155-.854 3.744-.854.686 0 2.514.2 3.647 1.887ZM12 6.353c-.228-1.107.403-2.213.99-2.919C13.743 2.579 14.929 2 15.952 2a4.047 4.047 0 0 1-1.088 2.982c-.664.854-1.807 1.497-2.862 1.37Z"
})), "0 0 24 24", "Apple");
exports.default = _default;